export enum PUBLIC_URIS {
  LOGIN = '/log-in',
  SIGNUP = '/signup',
  THE_MOTIVATION = '/the-motivation',
  THE_APP = '/the-app',
  REQUEST_DEMO = '/request-demo',
  KNOWLEDGE_BASE = '/knowledge-base',
  LEADERSHIP_AND_INVESTORS = '/leadership-and-investors',
  TEAM = '/team',
  CAREERS = '/careers',
  NEWSROOM = '/newsroom',
  CONTACT_US = '/contact-us',
  TERMS_OF_USE = '/terms-of-use',
  PRIVACY_POLICY = '/privacy-policy',
  SECURITY = '/security',
  POST_SUMMARY = '/p/:postId',
}
